<template lang="pug">
b-modal#editVipIcon(
  ref="editVipIcon"
  :title="$t('ui.combine.edit_vip_icon')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  size="lg"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    div.row.mb-3
      div.col-sm-12.col-md-6.col-lg-6
        b-form-group(:label="$t('ui.vip_name')" disabled label-class="font-weight-bold").mb-0
          DebounceInput(
            size="sm"
            ref="vip_name"
            type="text"
            v-model.trim.lazy="vip_name"
          )
    div.row(v-if="item")
      div.col-sm-12.col-md-6.col-lg-6
        b-form-group(:label="$t('ui.current_icon')" label-class="font-weight-bold")
          div.text-center.icon-preview
            b-img.fiximg.text-center(:src="imagePath + item.image_url" @error="handleImageError")
      div.col-sm-12.col-md-6.col-lg-6
        b-form-group(:label="$t('ui.new_icon')" label-class="font-weight-bold")
          .alert.alert-warning.p-1.mb-2.w-100 *{{ $t("message.banner_size_tooltips", { size: "80x83" }) }}
          b-form-group.w-100(:label="$t('ui.image')").mb-0
            b-form-file(
              :dirty="$v.img.$dirty"
              :error="$v.img.$error"
              v-model.trim.lazy="$v.img.$model"
              ref="file"
              accept="image/jpeg, image/png, image/jpg"
              @change="onSelect"
              v-if="imgSrc == null"
            )
            small.form-text.text-muted {{ $t('message.tooltips_upload_size') }} 
            ValidateResult(:value="$v.img" :name="$t('ui.image')")
            SubmitButton(
              :loading="loading"
              icon="fa fa-times"
              :text="$t('ui.remove')"
              type="button"
              @click="removeImage()"
              variant="danger"
              size="sm"
              v-if="imgSrc != null"
              )
            template(v-if="imgSrc != null")
              br
              b-img.w-50.h-50(:src="imgSrc")

  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import $ from 'jquery';
const fileSizeValidation = (value) =>  {
  if (!value) {
    return true;
  }
  let file = value;
  return (file.size < 1048576);
};
const base64Encode = data =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });


export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      vip_id: 0,
      vip_name: "",
      img_url: "",
      img: null,
      imageName: "",
      imgSrc: null,
      imagePath: config.viewImageUrl,
    };
  },
  computed: {
    loginId() {
      return this.$store.getters.loginId;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
  },
  validations: {
    img: {
      fileSizeValidation
    }
  },
  watch: {
    img(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.imgSrc = value;
            })
            .catch(() => {
              this.imgSrc = null;
            });
        } else {
          this.imgSrc = null;
        }
      }
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    removeImage() {
      this.img = null;
      this.img_url = "";
      this.imageName = "";
      this.imgSrc = null;
    },
    onSelect(evt) {
      if(evt.target.files.length > 0){
        this.imageName = evt.target.files[0].name;
      }else{
        return
      }
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.confirmSubmit();
      }
    },
    proceed() {
      let url = config.vipLogoUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        vip_id: this.vip_id,
        image_url: this.img_url,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.editVipIcon.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "edit_vip_icon", this.feedback.status);
                this.$refs.editVipIcon.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    async uploadImage() {
      if (this.imageName == "") return;

      const formData = new FormData();
      formData.append("file", this.img);
      this.loading = true;
      try {
        await this.$http
          .post(config.uploadImageUrl, formData)
          .then(function(response) {
            this.loading = false;
            if (response.data.file.filename) {
              this.img_url = response.data.file.filename;
            }
            // this.proceed();
          });
      } catch (err) {
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
      }
    },
    async confirmSubmit() {
      const p1 = this.uploadImage();
      const someResult = await p1;

      this.proceed();
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.vip_id = this.item.vip_id;
      this.vip_name = this.item.vip_name;
      this.imgSrc = null
      this.img_url = ""
      // this.imgSrc = this.item.image_url != null ? config.viewImageUrl + this.item.image_url : null;
      // this.img_url = this.item.image_url;
      this.imageName = "";
      $("#editVipIcon").find('.modal-content').first().removeAttr('tabindex');
    },
    handleImageError(event) {
      event.target.src = '/assets/img/vip/vip_default.png'; // Set fallback image
    },
  }
};
</script>

<style lang="scss" scoped>
.fiximg {
  height:83px;
  width:80px;
}

.icon-preview {
  height: 150px;
  background: #f5f5f5;
  border: 1px solid #dee2e6;
  border-radius: .5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>